// extracted by mini-css-extract-plugin
export default {"heroBody":"podcast-module--hero-body--e416b","headerStyle":"podcast-module--header-style--6ff98"};